/** Big, obvious "log something" buttons + the modals they open. */
import { useState, type ReactElement } from 'react';
import { effectiveLayout, sectionForMealType } from '../lib/diaryLayout';
import { mealTypeForNow } from '../lib/labels';
import { useApp } from '../state/app';
import { AddFoodModal } from './AddFoodModal';
import { AddWeightModal } from './AddWeightModal';
import { Icon, type IconName } from './Icon';
import { SaltModal } from './SaltModal';
import { Card } from './ui';

type Open = null | { kind: 'food'; tab: 'search' | 'barcode' | 'text' | 'photo'; section: string } | { kind: 'weight' } | { kind: 'salt' };

export function QuickAdd({ title = 'Quick add' }: { title?: string }): ReactElement {
  const { day, bump, settings } = useApp();
  const [open, setOpen] = useState<Open>(null);
  // The section for this time of day in the user's own layout.
  const nowSection = (): string => sectionForMealType(effectiveLayout(settings.diary_layout, settings.energy_mode), mealTypeForNow()).id;
  const face = (label: string, icon: IconName, color: string): ReactElement => (
    <><span className="qa-icon" style={{ background: color }}><Icon name={icon} size={20} /></span>{label}</>
  );
  const btn = (label: string, icon: IconName, color: string, onClick: () => void): ReactElement => (
    <button type="button" className="qa-btn" onClick={onClick}>{face(label, icon, color)}</button>
  );
  return (
    <Card title={title}>
      <div className="quick-add">
        {btn('Food', 'food', 'var(--carbs)', () => setOpen({ kind: 'food', tab: 'search', section: nowSection() }))}
        {btn('Scan', 'barcode', 'var(--alcohol)', () => setOpen({ kind: 'food', tab: 'barcode', section: nowSection() }))}
        {btn('Photo', 'camera', 'var(--protein)', () => setOpen({ kind: 'food', tab: 'photo', section: nowSection() }))}
        {btn('Weigh-in', 'scale', 'var(--energy)', () => setOpen({ kind: 'weight' }))}
        {/* Same origin as the lifting site, so the sign-in carries over. */}
        <a className="qa-btn" href="/lifting/">{face('Workout', 'dumbbell', 'var(--fat)')}</a>
      </div>
      <button type="button" className="btn btn-sm btn-ghost qa-salt" onClick={() => setOpen({ kind: 'salt' })}>
        <Icon name="salt" size={16} />Salty meal or ate out? Add the salt
      </button>
      {open?.kind === 'food' && <AddFoodModal day={day} defaultSectionId={open.section} initialTab={open.tab} onClose={() => setOpen(null)} onSaved={bump} />}
      {open?.kind === 'weight' && <AddWeightModal day={day} onClose={() => setOpen(null)} onSaved={bump} />}
      {open?.kind === 'salt' && <SaltModal onClose={() => setOpen(null)} />}
    </Card>
  );
}
